export const idTypeData = {
    'en_US': {
        'CN': [{
            name: "Identity card",
            value: "00860000001"
        }, {
            name: "Mainland Travel Permit for HK and Macao",
            value: "00860000006"
        }, {
            name: "China Mainland Travel Permit for Taiwan",
            value: "00860000007"
        }, {name: "Two-way Permit for HK and Macao", value: "00860000011"}
            , {name: "Passport", value: "00000001003"}],
        'PH': [{
            name: "Unified Multi-Purpose identity card",
            value: "00630000001"
        }, {
            name: "Taxpayer Identification Number",
            value: "00630000002"
        }, {
            name: "Driver’s license",
            value: "00630000004"
        }, {
            name: "PhilHealth ID",
            value: "00630000024"
        }, {
            name: "Social Security System",
            value: "00630000020"
        }, {
            name: "Postal ID",
            value: "00630000016"
        }, {
            name: "PRC ID",
            value: "00630000017"
        }, {
            name: "Voter's ID",
            value: "00630000022"
        }, {
            name: "Passport-old version",
            value: "00630000031"
        }, {
            name: "Passport-new version",
            value: "00630000032"
        }, {name: "Passport", value: "00000001003"}
        ],
        'MY': [{name: "MyKad", value: "00600000001"}, {name: "Passport", value: "00000001003"}],
        'ID': [{name: "te-KTP", value: "00620000001"}, {name: "Passport", value: "00000001003"}],
        'HK': [{
            name: "Current HKID (Hong Kong Identity Card)",
            value: "08520000001"
        }, {
            name: "New HKID (Hong Kong Identity Card)",
            value: "08520000002"
        }, {
            name: "China Mainland Travel Permit for Taiwan",
            value: "00860000007"
        }, {name: "Two-way Permit for HK and Macao", value: "00860000011"}
            , {name: "Passport", value: "00000001003"}],
        'MO': [{name: "Identity card", value: "08530000001"}, {name: "Passport", value: "00000001003"}],
        'TH': [{name: "Thailand ID Card", value: "00660000001"}, {name: "Passport", value: "00000001003"}],
        'VN': [{name: "Vietnam ID Card", value: "00840000001"}, {name: "Passport", value: "00000001003"}],
        'Other': [{name: "Passport", value: "00000001003"}]
    },
    'zh_HK': {
        'CN': [{
            name: "身份證",
            value: "00860000001"
        }, {
            name: "港澳居民来往内地通行证",
            value: "00860000006"
        }, {
            name: "中國大陸臺灣旅行許可證",
            value: "00860000007"
        }, {name: "中國大陸往來港澳通行證", value: "00860000011"}
            , {name: "護照", value: "00000001003"}],
        'PH': [{
            name: "統一多用途身份證",
            value: "00630000001"
        }, {
            name: "納稅人識別號",
            value: "00630000002"
        }, {
            name: "駕照",
            value: "00630000004"
        }, {
            name: "菲律賓身份證",
            value: "00630000024"
        }, {
            name: "臺灣身份證",
            value: "00630000020"
        }, {
            name: "日本身份證",
            value: "00630000016"
        }, {
            name: "中国居民身份证",
            value: "00630000017"
        }, {
            name: "印度身份證",
            value: "00630000022"
        }, {
            name: "舊版護照",
            value: "00630000031"
        }, {
            name: "新版護照",
            value: "00630000032"
        }, {name: "護照", value: "00000001003"}
        ],
        'MY': [{name: "馬來西亞身份證", value: "00600000001"}, {name: "護照", value: "00000001003"}],
        'ID': [{name: "印尼身份證", value: "00620000001"}, {name: "護照", value: "00000001003"}],
        'HK': [{
            name: "當前香港身份證",
            value: "08520000001"
        }, {
            name: "新香港身份證",
            value: "08520000002"
        }, {
            name: "中國大陸臺灣旅行許可證",
            value: "00860000007"
        }, {name: "中國大陸往來港澳通行證", value: "00860000011"}
            , {name: "護照", value: "00000001003"}],
        'MO': [{name: "身份證", value: "08530000001"}, {name: "護照", value: "00000001003"}],
        'TH': [{name: "泰國身份證", value: "00660000001"}, {name: "護照", value: "00000001003"}],
        'VN': [{name: "越南身份證", value: "00840000001"}, {name: "護照", value: "00000001003"}],
        'Other': [{name: "護照", value: "00000001003"}]
    },
    'ko_KR': {
        'CN': [{
            name: "신분증",
            value: "00860000001"
        }, {
            name: "홍콩, 마카오 주민 왕래 내륙 통행증",
            value: "00860000006"
        }, {
            name: "중국 대륙 대만 여행 허가증",
            value: "00860000007"
        }, {name: "중국 대륙 왕래 홍콩, 마카오 통행증", value: "00860000011"}
            , {name: "여권", value: "00000001003"}],
        'PH': [{
            name: "다용도 신분증 통일",
            value: "00630000001"
        }, {
            name: "납세자 식별번호",
            value: "00630000002"
        }, {
            name: "면허증",
            value: "00630000004"
        }, {
            name: "필리핀 신분증",
            value: "00630000024"
        }, {
            name: "대만 신분증",
            value: "00630000020"
        }, {
            name: "일본 신분증",
            value: "00630000016"
        }, {
            name: "중국주민등록증",
            value: "00630000017"
        }, {
            name: "인도 신분증",
            value: "00630000022"
        }, {
            name: "구판 여권",
            value: "00630000031"
        }, {
            name: "새 여권",
            value: "00630000032"
        }, {name: "여권", value: "00000001003"}
        ],
        'MY': [{name: "말레이시아 신분증", value: "00600000001"}, {name: "여권", value: "00000001003"}],
        'ID': [{name: "인도네시아 신분증", value: "00620000001"}, {name: "여권", value: "00000001003"}],
        'HK': [{
            name: "현재 홍콩 신분증",
            value: "08520000001"
        }, {
            name: "신홍콩 신분증",
            value: "08520000002"
        }, {
            name: "중국 대륙 대만 여행 허가증",
            value: "00860000007"
        }, {name: "중국 대륙 왕래 홍콩, 마카오 통행증", value: "00860000011"}
            , {name: "여권", value: "00000001003"}],
        'MO': [{name: "신분증", value: "08530000001"}, {name: "여권", value: "00000001003"}],
        'TH': [{name: "태국 신분증", value: "00660000001"}, {name: "여권", value: "00000001003"}],
        'VN': [{name: "베트남 신분증", value: "00840000001"}, {name: "여권", value: "00000001003"}],
        'Other': [{name: "여권", value: "00000001003"}]
    },
    'ru': {
        'CN': [{
            name: "удостоверение личности",
            value: "00860000001"
        }, {
            name: "разрешение на выезд из Сянгана и Аомэня",
            value: "00860000006"
        }, {
            name: "разрешение на поездку на тайвань, материковый китай",
            value: "00860000007"
        }, {name: "пропуска в сянган и Аомэнь на материковой части Китая", value: "00860000011"}
            , {name: "паспорт", value: "00000001003"}],
        'PH': [{
            name: "единый многоцелевой паспорт",
            value: "00630000001"
        }, {
            name: "идентификационный номер налогоплательщика",
            value: "00630000002"
        }, {
            name: "водительские права",
            value: "00630000004"
        }, {
            name: "Филиппинский паспорт",
            value: "00630000024"
        }, {
            name: "тайваньский паспорт",
            value: "00630000020"
        }, {
            name: "удостоверение личности Японии",
            value: "00630000016"
        }, {
            name: "удостоверение личности китайского гражданина",
            value: "00630000017"
        }, {
            name: "индийское удостоверение личности",
            value: "00630000022"
        }, {
            name: "старый паспорт",
            value: "00630000031"
        }, {
            name: "новый паспорт",
            value: "00630000032"
        }, {name: "паспорт", value: "00000001003"}
        ],
        'MY': [{name: "Малайзийское удостоверение личности", value: "00600000001"}, {
            name: "паспорт",
            value: "00000001003"
        }],
        'ID': [{name: "Индонезийское удостоверение личности", value: "00620000001"}, {
            name: "паспорт",
            value: "00000001003"
        }],
        'HK': [{
            name: "текущий паспорт Гонконга",
            value: "08520000001"
        }, {
            name: "удостоверение личности нового гонконга",
            value: "08520000002"
        }, {
            name: "разрешение на поездку на тайвань, материковый китай",
            value: "00860000007"
        }, {name: "пропуска в Гонконг и Аомэнь на материковой части Китая", value: "00860000011"}
            , {name: "паспорт", value: "00000001003"}],
        'MO': [{name: "удостоверение личности", value: "08530000001"}, {name: "паспорт", value: "00000001003"}],
        'TH': [{name: "тайское удостоверение личности", value: "00660000001"}, {name: "паспорт", value: "00000001003"}],
        'VN': [{name: "Вьетнамское удостоверение личности", value: "00840000001"}, {
            name: "паспорт",
            value: "00000001003"
        }],
        'Other': [{name: "паспорт", value: "00000001003"}]
    }
}


export const countryStaticDataKR = [
    {
        "name": "알랜드 제도",
        "value": "AX"
    },
    {
        "name": "아프가니스탄",
        "value": "AF"
    },
    {
        "name": "알바니아",
        "value": "AL"
    },
    {
        "name": "알제리",
        "value": "DZ"
    },
    {
        "name": "아메리칸 사모아",
        "value": "AS"
    },
    {
        "name": "안도라",
        "value": "AD"
    },
    {
        "name": "앙골라",
        "value": "AO"
    },
    {
        "name": "앵귈라",
        "value": "AI"
    },
    {
        "name": "남극",
        "value": "AQ"
    },
    {
        "name": "앤티가 바부다",
        "value": "AG"
    },
    {
        "name": "아르헨티나",
        "value": "AR"
    },
    {
        "name": "아르메니아",
        "value": "AM"
    },
    {
        "name": "아루바",
        "value": "AW"
    },
    {
        "name": "호주",
        "value": "AU"
    },
    {
        "name": "오스트리아",
        "value": "AT"
    },
    {
        "name": "아제르바이잔",
        "value": "AZ"
    },
    {
        "name": "바하마",
        "value": "BS"
    },
    {
        "name": "바레인",
        "value": "BH"
    },
    {
        "name": "방글라데시",
        "value": "BD"
    },
    {
        "name": "바베이도스",
        "value": "BB"
    },
    {
        "name": "벨라루스",
        "value": "BY"
    },
    {
        "name": "벨기에",
        "value": "BE"
    },
    {
        "name": "벨리즈",
        "value": "BZ"
    },
    {
        "name": "베냉",
        "value": "BJ"
    },
    {
        "name": "버뮤다",
        "value": "BM"
    },
    {
        "name": "부탄",
        "value": "BT"
    },
    {
        "name": "볼리비아",
        "value": "BO"
    },
    {
        "name": "보스니아 헤르체고위나",
        "value": "BA"
    },
    {
        "name": "보츠와나",
        "value": "BW"
    },
    {
        "name": "부베 아일랜드",
        "value": "BV"
    },
    {
        "name": "브라질",
        "value": "BR"
    },
    {
        "name": "영국령 인도양 영토",
        "value": "IO"
    },
    {
        "name": "브루나이 다루살람",
        "value": "BN"
    },
    {
        "name": "불가리아",
        "value": "BG"
    },
    {
        "name": "부키 나 파소",
        "value": "BF"
    },
    {
        "name": "부룬디",
        "value": "BI"
    },
    {
        "name": "캄보디아",
        "value": "KH"
    },
    {
        "name": "카메룬",
        "value": "CM"
    },
    {
        "name": "캐나다",
        "value": "CA"
    },
    {
        "name": "케이프 베르데",
        "value": "CV"
    },
    {
        "name": "케이맨 제도",
        "value": "KY"
    },
    {
        "name": "중앙 아프리카 공화국",
        "value": "CF"
    },
    {
        "name": "차드",
        "value": "TD"
    },
    {
        "name": "칠레",
        "value": "CL"
    },
    {
        "name": "중국",
        "value": "CN"
    },
    {
        "name": "크리스마스 아일랜드",
        "value": "CX"
    },
    {
        "name": "코코스(킬링) 제도",
        "value": "CC"
    },
    {
        "name": "콜롬비아",
        "value": "CO"
    },
    {
        "name": "코모로",
        "value": "KM"
    },
    {
        "name": "콩고민주공화국",
        "value": "CD"
    },
    {
        "name": "콩고 공화국",
        "value": "CG"
    },
    {
        "name": "쿡 제도",
        "value": "CK"
    },
    {
        "name": "코스타리카",
        "value": "CR"
    },
    {
        "name": "코트디부아르",
        "value": "CI"
    },
    {
        "name": "크로아티아",
        "value": "HR"
    },
    {
        "name": "쿠바",
        "value": "CU"
    },
    {
        "name": "키프로스",
        "value": "CY"
    },
    {
        "name": "체코 공화국",
        "value": "CZ"
    },
    {
        "name": "덴마크",
        "value": "DK"
    },
    {
        "name": "지부티",
        "value": "DJ"
    },
    {
        "name": "도미니카",
        "value": "DM"
    },
    {
        "name": "도미니카 공화국",
        "value": "DO"
    },
    {
        "name": "에콰도르",
        "value": "EC"
    },
    {
        "name": "이집트",
        "value": "EG"
    },
    {
        "name": "엘살바도르",
        "value": "SV"
    },
    {
        "name": "적도 기니",
        "value": "GQ"
    },
    {
        "name": "에리트레아",
        "value": "ER"
    },
    {
        "name": "에스토니아",
        "value": "EE"
    },
    {
        "name": "에티오피아",
        "value": "ET"
    },
    {
        "name": "포클랜드 제도(말비나스)",
        "value": "FK"
    },
    {
        "name": "페로 제도",
        "value": "FO"
    },
    {
        "name": "피지",
        "value": "FJ"
    },
    {
        "name": "핀란드",
        "value": "FI"
    },
    {
        "name": "프랑스",
        "value": "FR"
    },
    {
        "name": "프랑스령 기아나",
        "value": "GF"
    },
    {
        "name": "프랑스 령 폴리네시아의",
        "value": "PF"
    },
    {
        "name": "프랑스 남부 영토",
        "value": "TF"
    },
    {
        "name": "가봉",
        "value": "GA"
    },
    {
        "name": "감비아",
        "value": "GM"
    },
    {
        "name": "그루지야",
        "value": "GE"
    },
    {
        "name": "독일",
        "value": "DE"
    },
    {
        "name": "가나",
        "value": "GH"
    },
    {
        "name": "지브롤터",
        "value": "GI"
    },
    {
        "name": "그리스",
        "value": "GR"
    },
    {
        "name": "그린란드",
        "value": "GL"
    },
    {
        "name": "그레나다",
        "value": "GD"
    },
    {
        "name": "과들루프",
        "value": "GP"
    },
    {
        "name": "괌",
        "value": "GU"
    },
    {
        "name": "과테말라",
        "value": "GT"
    },
    {
        "name": "기니",
        "value": "GN"
    },
    {
        "name": "기니비사우",
        "value": "GW"
    },
    {
        "name": "가이아나",
        "value": "GY"
    },
    {
        "name": "아이티",
        "value": "HT"
    },
    {
        "name": "허드 앤 MC 도널드 아일랜드",
        "value": "HM"
    },
    {
        "name": "온두라스",
        "value": "HN"
    },
    {
        "name": "홍콩, 중국",
        "value": "HK"
    },
    {
        "name": "헝가리",
        "value": "HU"
    },
    {
        "name": "아이슬란드",
        "value": "IS"
    },
    {
        "name": "인도",
        "value": "IN"
    },
    {
        "name": "인도네시아",
        "value": "ID"
    },
    {
        "name": "이란(이슬람 공화국)",
        "value": "IR"
    },
    {
        "name": "이라크",
        "value": "IQ"
    },
    {
        "name": "아일랜드",
        "value": "IE"
    },
    {
        "name": "이스라엘",
        "value": "IL"
    },
    {
        "name": "이탈리아",
        "value": "IT"
    },
    {
        "name": "자메이카",
        "value": "JM"
    },
    {
        "name": "일본",
        "value": "JP"
    },
    {
        "name": "요르단",
        "value": "JO"
    },
    {
        "name": "카자흐스탄",
        "value": "KZ"
    },
    {
        "name": "케냐",
        "value": "KE"
    },
    {
        "name": "키리바시",
        "value": "KI"
    },
    {
        "name": "조선민주주의인민공화국",
        "value": "KP"
    },
    {
        "name": "대한민국",
        "value": "KR"
    },
    {
        "name": "쿠웨이트",
        "value": "KW"
    },
    {
        "name": "키르기스스탄",
        "value": "KG"
    },
    {
        "name": "라오스 민주 공화국",
        "value": "LA"
    },
    {
        "name": "라트비아",
        "value": "LV"
    },
    {
        "name": "레바논",
        "value": "LB"
    },
    {
        "name": "레소토",
        "value": "LS"
    },
    {
        "name": "라이베리아",
        "value": "LR"
    },
    {
        "name": "리비아 아랍 자마히리야",
        "value": "LY"
    },
    {
        "name": "라이텐슈타인",
        "value": "LI"
    },
    {
        "name": "리투아니아",
        "value": "LT"
    },
    {
        "name": "룩셈부르크",
        "value": "LU"
    },
    {
        "name": "마카오, 중국",
        "value": "MO"
    },
    {
        "name": "마케도니아, 구 유고슬라비아 공화국",
        "value": "MK"
    },
    {
        "name": "마다가스카르",
        "value": "MG"
    },
    {
        "name": "말라위",
        "value": "MW"
    },
    {
        "name": "말레이시아",
        "value": "MY"
    },
    {
        "name": "몰디브",
        "value": "MV"
    },
    {
        "name": "말리",
        "value": "ML"
    },
    {
        "name": "몰타",
        "value": "MT"
    },
    {
        "name": "마셜 제도",
        "value": "MH"
    },
    {
        "name": "마티니크",
        "value": "MQ"
    },
    {
        "name": "모리타니",
        "value": "MR"
    },
    {
        "name": "모리셔스",
        "value": "MU"
    },
    {
        "name": "마요트",
        "value": "YT"
    },
    {
        "name": "멕시코",
        "value": "MX"
    },
    {
        "name": "미크로네시아, 연방",
        "value": "FM"
    },
    {
        "name": "몰도바",
        "value": "MD"
    },
    {
        "name": "모나코",
        "value": "MC"
    },
    {
        "name": "몽골리아",
        "value": "MN"
    },
    {
        "name": "몬세라트",
        "value": "MS"
    },
    {
        "name": "모로코",
        "value": "MA"
    },
    {
        "name": "모잠비크",
        "value": "MZ"
    },
    {
        "name": "미얀마",
        "value": "MM"
    },
    {
        "name": "나미비아",
        "value": "NA"
    },
    {
        "name": "나우루",
        "value": "NR"
    },
    {
        "name": "네팔",
        "value": "NP"
    },
    {
        "name": "네덜란드",
        "value": "NL"
    },
    {
        "name": "네덜란드 령 앤 틸리 스",
        "value": "AN"
    },
    {
        "name": "뉴 칼레도니아",
        "value": "NC"
    },
    {
        "name": "뉴질랜드",
        "value": "NZ"
    },
    {
        "name": "니카라과",
        "value": "NI"
    },
    {
        "name": "니제르",
        "value": "NE"
    },
    {
        "name": "나이지리아",
        "value": "NG"
    },
    {
        "name": "니우에",
        "value": "NU"
    },
    {
        "name": "노퍽 섬",
        "value": "NF"
    },
    {
        "name": "북마리아나 제도",
        "value": "MP"
    },
    {
        "name": "노르웨이",
        "value": "NO"
    },
    {
        "name": "오만",
        "value": "OM"
    },
    {
        "name": "파키스탄",
        "value": "PK"
    },
    {
        "name": "팔라우",
        "value": "PW"
    },
    {
        "name": "팔레스타인 영토",
        "value": "PS"
    },
    {
        "name": "파나마",
        "value": "PA"
    },
    {
        "name": "파푸아 뉴기니",
        "value": "PG"
    },
    {
        "name": "파라과이",
        "value": "PY"
    },
    {
        "name": "페루",
        "value": "PE"
    },
    {
        "name": "필리핀 제도",
        "value": "PH"
    },
    {
        "name": "핏케른",
        "value": "PN"
    },
    {
        "name": "폴란드",
        "value": "PL"
    },
    {
        "name": "포르투갈",
        "value": "PT"
    },
    {
        "name": "푸에르토 리코",
        "value": "PR"
    },
    {
        "name": "카타르",
        "value": "QA"
    },
    {
        "name": "재결합",
        "value": "RE"
    },
    {
        "name": "루마니아",
        "value": "RO"
    },
    {
        "name": "러시아 연방",
        "value": "RU"
    },
    {
        "name": "르완다",
        "value": "RW"
    },
    {
        "name": "세인트 헬레나",
        "value": "SH"
    },
    {
        "name": "세인트키츠와 네비스",
        "value": "KN"
    },
    {
        "name": "세인트루시아",
        "value": "LC"
    },
    {
        "name": "생 피에르와 미클롱",
        "value": "PM"
    },
    {
        "name": "세인트 빈센트 그레나딘",
        "value": "VC"
    },
    {
        "name": "사모아",
        "value": "WS"
    },
    {
        "name": "산 마리노",
        "value": "SM"
    },
    {
        "name": "상투메프린시페",
        "value": "ST"
    },
    {
        "name": "사우디 아라비아",
        "value": "SA"
    },
    {
        "name": "세네갈",
        "value": "SN"
    },
    {
        "name": "세르비아와 몬테네그로",
        "value": "CS"
    },
    {
        "name": "세이셸",
        "value": "SC"
    },
    {
        "name": "시에라리온",
        "value": "SL"
    },
    {
        "name": "싱가포르",
        "value": "SG"
    },
    {
        "name": "슬로바키아",
        "value": "SK"
    },
    {
        "name": "슬로베니아",
        "value": "SI"
    },
    {
        "name": "솔로몬 제도",
        "value": "SB"
    },
    {
        "name": "소말리아",
        "value": "SO"
    },
    {
        "name": "남아프리카",
        "value": "ZA"
    },
    {
        "name": "사우스 조지아와 사우스 샌드위치 제도",
        "value": "DS"
    },
    {
        "name": "스페인",
        "value": "ES"
    },
    {
        "name": "스리랑카",
        "value": "LK"
    },
    {
        "name": "수단",
        "value": "SD"
    },
    {
        "name": "수리남",
        "value": "SR"
    },
    {
        "name": "스발바르와 얀마옌 제도",
        "value": "SJ"
    },
    {
        "name": "스와질랜드",
        "value": "SZ"
    },
    {
        "name": "스웨덴",
        "value": "SE"
    },
    {
        "name": "스위스",
        "value": "CH"
    },
    {
        "name": "시리아 아랍 공화국",
        "value": "SY"
    },
    {
        "name": "대만, 중국",
        "value": "TW"
    },
    {
        "name": "타지키스탄",
        "value": "TJ"
    },
    {
        "name": "탄자니아, 연합 공화국",
        "value": "TZ"
    },
    {
        "name": "태국",
        "value": "TH"
    },
    {
        "name": "동티모르",
        "value": "TL"
    },
    {
        "name": "토고",
        "value": "TG"
    },
    {
        "name": "토켈라우",
        "value": "TK"
    },
    {
        "name": "통가",
        "value": "TO"
    },
    {
        "name": "트리니다드토바고",
        "value": "TT"
    },
    {
        "name": "튀니지",
        "value": "TN"
    },
    {
        "name": "칠면조",
        "value": "TR"
    },
    {
        "name": "투르크메니스탄",
        "value": "TM"
    },
    {
        "name": "터크스케이커스 제도",
        "value": "TC"
    },
    {
        "name": "투발루",
        "value": "TV"
    },
    {
        "name": "우간다",
        "value": "UG"
    },
    {
        "name": "우크라이나",
        "value": "UA"
    },
    {
        "name": "아랍 에미리트",
        "value": "AE"
    },
    {
        "name": "영국",
        "value": "GB"
    },
    {
        "name": "미국",
        "value": "US"
    },
    {
        "name": "미국 작은 외딴 섬",
        "value": "UM"
    },
    {
        "name": "우루과이",
        "value": "UY"
    },
    {
        "name": "우즈베키스탄",
        "value": "UZ"
    },
    {
        "name": "바누아투",
        "value": "VU"
    },
    {
        "name": "바티칸 시국(교황청)",
        "value": "VA"
    },
    {
        "name": "베네수엘라",
        "value": "VE"
    },
    {
        "name": "베트남",
        "value": "VN"
    },
    {
        "name": "버진 아일랜드(영국)",
        "value": "VG"
    },
    {
        "name": "버진 아일랜드(미국)",
        "value": "VI"
    },
    {
        "name": "월리스 및 푸투나 제도",
        "value": "WF"
    },
    {
        "name": "서부 사하라",
        "value": "EH"
    },
    {
        "name": "예멘",
        "value": "YE"
    },
    {
        "name": "잠비아",
        "value": "ZM"
    },
    {
        "name": "짐바브웨",
        "value": "ZW"
    }
]

export const countryStaticDataRU = [
    {
        "name": "АЛАНДСКИЕ ОСТРОВА",
        "value": "AX"
    },
    {
        "name": "АФГАНИСТАН",
        "value": "AF"
    },
    {
        "name": "АЛБАНИЯ",
        "value": "AL"
    },
    {
        "name": "АЛЖИР",
        "value": "DZ"
    },
    {
        "name": "АМЕРИКАНСКОЕ САМОА",
        "value": "AS"
    },
    {
        "name": "АНДОРРА",
        "value": "AD"
    },
    {
        "name": "АНГОЛА",
        "value": "AO"
    },
    {
        "name": "АНГИЛЬЯ",
        "value": "AI"
    },
    {
        "name": "АНТАРКТИДА",
        "value": "AQ"
    },
    {
        "name": "АНТИГУА И БАРБУДА",
        "value": "AG"
    },
    {
        "name": "АРГЕНТИНА",
        "value": "AR"
    },
    {
        "name": "АРМЕНИЯ",
        "value": "AM"
    },
    {
        "name": "АРУБА",
        "value": "AW"
    },
    {
        "name": "АВСТРАЛИЯ",
        "value": "AU"
    },
    {
        "name": "АВСТРИЯ",
        "value": "AT"
    },
    {
        "name": "АЗЕРБАЙДЖАН",
        "value": "AZ"
    },
    {
        "name": "БАГАМСКИЕ ОСТРОВА",
        "value": "BS"
    },
    {
        "name": "БАХРЕЙН",
        "value": "BH"
    },
    {
        "name": "БАНГЛАДЕШ",
        "value": "BD"
    },
    {
        "name": "БАРБАДОС",
        "value": "BB"
    },
    {
        "name": "БЕЛАРУСЬ",
        "value": "BY"
    },
    {
        "name": "БЕЛЬГИЯ",
        "value": "BE"
    },
    {
        "name": "БЕЛИЗ",
        "value": "BZ"
    },
    {
        "name": "БЕНИН",
        "value": "BJ"
    },
    {
        "name": "БЕРМУДСКИЕ ОСТРОВА",
        "value": "BM"
    },
    {
        "name": "БУТАН",
        "value": "BT"
    },
    {
        "name": "БОЛИВИЯ",
        "value": "BO"
    },
    {
        "name": "БОСНИЯ И ГЕРЦЕГОВИНА",
        "value": "BA"
    },
    {
        "name": "БОТСВАНА",
        "value": "BW"
    },
    {
        "name": "ОСТРОВ БУВЕ",
        "value": "BV"
    },
    {
        "name": "БРАЗИЛИЯ",
        "value": "BR"
    },
    {
        "name": "БРИТАНСКАЯ ТЕРРИТОРИЯ ИНДИЙСКОГО ОКЕАНА",
        "value": "IO"
    },
    {
        "name": "БРУНЕЙ-ДАРУССАЛАМ",
        "value": "BN"
    },
    {
        "name": "БОЛГАРИЯ",
        "value": "BG"
    },
    {
        "name": "БУРКИНА-ФАСО",
        "value": "BF"
    },
    {
        "name": "БУРУНДИ",
        "value": "BI"
    },
    {
        "name": "КАМБОДЖА",
        "value": "KH"
    },
    {
        "name": "КАМЕРУН",
        "value": "CM"
    },
    {
        "name": "КАНАДА",
        "value": "CA"
    },
    {
        "name": "КАБО-ВЕРДЕ",
        "value": "CV"
    },
    {
        "name": "КАЙМАНОВЫ ОСТРОВА",
        "value": "KY"
    },
    {
        "name": "ЦЕНТРАЛЬНО-АФРИКАНСКАЯ РЕСПУБЛИКА",
        "value": "CF"
    },
    {
        "name": "ЧАД",
        "value": "TD"
    },
    {
        "name": "ЧИЛИ",
        "value": "CL"
    },
    {
        "name": "КИТАЙ",
        "value": "CN"
    },
    {
        "name": "ОСТРОВ РОЖДЕСТВА",
        "value": "CX"
    },
    {
        "name": "КОКОСОВЫЕ (КИЛИНГ) ОСТРОВА",
        "value": "CC"
    },
    {
        "name": "КОЛУМБИЯ",
        "value": "CO"
    },
    {
        "name": "КОМОРСКИЕ ОСТРОВА",
        "value": "KM"
    },
    {
        "name": "КОНГО, Демократическая Республика",
        "value": "CD"
    },
    {
        "name": "КОНГО, Республика",
        "value": "CG"
    },
    {
        "name": "ОСТРОВА КУКА",
        "value": "CK"
    },
    {
        "name": "КОСТА-РИКА",
        "value": "CR"
    },
    {
        "name": "БЕРЕГ СЛОНОВОЙ КОСТИ",
        "value": "CI"
    },
    {
        "name": "ХОРВАТИЯ",
        "value": "HR"
    },
    {
        "name": "КУБА",
        "value": "CU"
    },
    {
        "name": "КИПР",
        "value": "CY"
    },
    {
        "name": "ЧЕШСКАЯ РЕСПУБЛИКА",
        "value": "CZ"
    },
    {
        "name": "ДАНИЯ",
        "value": "DK"
    },
    {
        "name": "ДЖИБУТИ",
        "value": "DJ"
    },
    {
        "name": "ДОМИНИКА",
        "value": "DM"
    },
    {
        "name": "ДОМИНИКАНСКАЯ РЕСПБЛИКА",
        "value": "DO"
    },
    {
        "name": "ЭКВАДОР",
        "value": "EC"
    },
    {
        "name": "ЕГИПЕТ",
        "value": "EG"
    },
    {
        "name": "ЭЛЬ САЛЬВАДОР",
        "value": "SV"
    },
    {
        "name": "ЭКВАТОРИАЛЬНАЯ ГВИНЕЯ",
        "value": "GQ"
    },
    {
        "name": "ЭРИТРЕЯ",
        "value": "ER"
    },
    {
        "name": "ЭСТОНИЯ",
        "value": "EE"
    },
    {
        "name": "ЭФИОПИЯ",
        "value": "ET"
    },
    {
        "name": "ФОЛКЛЕНДСКИЕ (МАЛЬВИНСКИЕ) ОСТРОВА",
        "value": "FK"
    },
    {
        "name": "ФАРЕРСКИЕ ОСТРОВА",
        "value": "FO"
    },
    {
        "name": "ФИДЖИ",
        "value": "FJ"
    },
    {
        "name": "ФИНЛЯНДИЯ",
        "value": "FI"
    },
    {
        "name": "ФРАНЦИЯ",
        "value": "FR"
    },
    {
        "name": "ФРАНЦУЗСКАЯ ГВИАНА",
        "value": "GF"
    },
    {
        "name": "ФРАНЦУЗСКАЯ ПОЛИНЕЗИЯ",
        "value": "PF"
    },
    {
        "name": "ЮЖНЫЕ ФРАНЦУЗСКИЕ ТЕРРИТОРИИ",
        "value": "TF"
    },
    {
        "name": "ГАБОН",
        "value": "GA"
    },
    {
        "name": "ГАМБИЯ",
        "value": "GM"
    },
    {
        "name": "ГРУЗИЯ",
        "value": "GE"
    },
    {
        "name": "ГЕРМАНИЯ",
        "value": "DE"
    },
    {
        "name": "ГАНА",
        "value": "GH"
    },
    {
        "name": "ГИБРАЛТАР",
        "value": "GI"
    },
    {
        "name": "ГРЕЦИЯ",
        "value": "GR"
    },
    {
        "name": "ГРЕНЛАНДИЯ",
        "value": "GL"
    },
    {
        "name": "ГРЕНАДА",
        "value": "GD"
    },
    {
        "name": "ГВАДЕЛУПА",
        "value": "GP"
    },
    {
        "name": "ГУАМ",
        "value": "GU"
    },
    {
        "name": "ГВАТЕМАЛА",
        "value": "GT"
    },
    {
        "name": "ГВИНЕЯ",
        "value": "GN"
    },
    {
        "name": "ГВИНЕЯ-БИСАУ",
        "value": "GW"
    },
    {
        "name": "ГАЙАНА",
        "value": "GY"
    },
    {
        "name": "ГАИТИ",
        "value": "HT"
    },
    {
        "name": "ХЕРД И МС ОСТРОВА ДОНАЛЬД",
        "value": "HM"
    },
    {
        "name": "ГОНДУРАС",
        "value": "HN"
    },
    {
        "name": "ГОНКОНГ, КИТАЙ",
        "value": "HK"
    },
    {
        "name": "ВЕНГРИЯ",
        "value": "HU"
    },
    {
        "name": "ИСЛАНДИЯ",
        "value": "IS"
    },
    {
        "name": "ИНДИЯ",
        "value": "IN"
    },
    {
        "name": "ИНДОНЕЗИЯ",
        "value": "ID"
    },
    {
        "name": "ИРАН (ИСЛАМСКАЯ РЕСПУБЛИКА)",
        "value": "IR"
    },
    {
        "name": "ИРАК",
        "value": "IQ"
    },
    {
        "name": "ИРЛАНДИЯ",
        "value": "IE"
    },
    {
        "name": "ИЗРАИЛЬ",
        "value": "IL"
    },
    {
        "name": "ИТАЛИЯ",
        "value": "IT"
    },
    {
        "name": "ЯМАЙКА",
        "value": "JM"
    },
    {
        "name": "ЯПОНИЯ",
        "value": "JP"
    },
    {
        "name": "ИОРДАНИЯ",
        "value": "JO"
    },
    {
        "name": "КАЗАХСТАН",
        "value": "KZ"
    },
    {
        "name": "КЕНИЯ",
        "value": "KE"
    },
    {
        "name": "КИРИБАТИ",
        "value": "KI"
    },
    {
        "name": "КОРЕЯ, НАРОДНО-ДЕМОКРАТИЧЕСКАЯ РЕСПУБЛИКА",
        "value": "KP"
    },
    {
        "name": "КОРЕЯ, РЕСПУБЛИКА",
        "value": "KR"
    },
    {
        "name": "КУВЕЙТ",
        "value": "KW"
    },
    {
        "name": "КЫРГЫЗСТАН",
        "value": "KG"
    },
    {
        "name": "ЛАОССКАЯ НАРОДНО-ДЕМОКРАТИЧЕСКАЯ РЕСПУБЛИКА",
        "value": "LA"
    },
    {
        "name": "ЛАТВИЯ",
        "value": "LV"
    },
    {
        "name": "ЛИВАН",
        "value": "LB"
    },
    {
        "name": "ЛЕСОТО",
        "value": "LS"
    },
    {
        "name": "ЛИБЕРИЯ",
        "value": "LR"
    },
    {
        "name": "ЛИВИЙСКАЯ АРАБСКАЯ ДЖАМАХИРИЯ",
        "value": "LY"
    },
    {
        "name": "ЛИХТЕНШТЕЙН",
        "value": "LI"
    },
    {
        "name": "ЛИТВА",
        "value": "LT"
    },
    {
        "name": "ЛЮКСЕМБУРГ",
        "value": "LU"
    },
    {
        "name": "МАКАО, КИТАЙ",
        "value": "MO"
    },
    {
        "name": "МАКЕДОНИЯ, БЫВШАЯ ЮГОСЛАВСКАЯ РЕСПУБЛИКА",
        "value": "MK"
    },
    {
        "name": "МАДАГАСКАР",
        "value": "MG"
    },
    {
        "name": "МАЛАВИ",
        "value": "MW"
    },
    {
        "name": "МАЛАЙЗИЯ",
        "value": "MY"
    },
    {
        "name": "МАЛЬДИВЫ",
        "value": "MV"
    },
    {
        "name": "МАЛИ",
        "value": "ML"
    },
    {
        "name": "МАЛЬТА",
        "value": "MT"
    },
    {
        "name": "МАРШАЛЛОВЫ ОСТРОВА",
        "value": "MH"
    },
    {
        "name": "МАРТИНИКА",
        "value": "MQ"
    },
    {
        "name": "МАВРИТАНИЯ",
        "value": "MR"
    },
    {
        "name": "МАВРИКИЙ",
        "value": "MU"
    },
    {
        "name": "МАЙОТТА",
        "value": "YT"
    },
    {
        "name": "МЕКСИКА",
        "value": "MX"
    },
    {
        "name": "МИКРОНЕЗИЯ, ФЕДЕРАТИВНЫЕ ШТАТЫ",
        "value": "FM"
    },
    {
        "name": "МОЛДОВА, РЕСПУБЛИКА",
        "value": "MD"
    },
    {
        "name": "МОНАКО",
        "value": "MC"
    },
    {
        "name": "МОНГОЛИЯ",
        "value": "MN"
    },
    {
        "name": "МОНТСЕРРАТ",
        "value": "MS"
    },
    {
        "name": "МАРОККО",
        "value": "MA"
    },
    {
        "name": "МОЗАМБИК",
        "value": "MZ"
    },
    {
        "name": "МЬЯНМА",
        "value": "MM"
    },
    {
        "name": "НАМИБИЯ",
        "value": "NA"
    },
    {
        "name": "НАУРУ",
        "value": "NR"
    },
    {
        "name": "НЕПАЛ",
        "value": "NP"
    },
    {
        "name": "НИДЕРЛАНДЫ",
        "value": "NL"
    },
    {
        "name": "НИДЕРЛАНДСКИЕ АНТИЛЬСКИЕ ОСТРОВА",
        "value": "AN"
    },
    {
        "name": "НОВАЯ КАЛЕДОНИЯ",
        "value": "NC"
    },
    {
        "name": "НОВАЯ ЗЕЛАНДИЯ",
        "value": "NZ"
    },
    {
        "name": "НИКАРАГУА",
        "value": "NI"
    },
    {
        "name": "НИГЕР",
        "value": "NE"
    },
    {
        "name": "НИГЕРИЯ",
        "value": "NG"
    },
    {
        "name": "НИУЭ",
        "value": "NU"
    },
    {
        "name": "ОСТРОВ НОРФОЛК",
        "value": "NF"
    },
    {
        "name": "СЕВЕРНЫЕ МАРИАНСКИЕ ОСТРОВА",
        "value": "MP"
    },
    {
        "name": "НОРВЕГИЯ",
        "value": "NO"
    },
    {
        "name": "ОМАН",
        "value": "OM"
    },
    {
        "name": "ПАКИСТАН",
        "value": "PK"
    },
    {
        "name": "ПАЛАУ",
        "value": "PW"
    },
    {
        "name": "ПАЛЕСТИНСКАЯ ТЕРРИТОРИЯ",
        "value": "PS"
    },
    {
        "name": "ПАНАМА",
        "value": "PA"
    },
    {
        "name": "ПАПУА - НОВАЯ ГВИНЕЯ",
        "value": "PG"
    },
    {
        "name": "ПАРАГВАЙ",
        "value": "PY"
    },
    {
        "name": "ПЕРУ",
        "value": "PE"
    },
    {
        "name": "ФИЛИППИНЫ",
        "value": "PH"
    },
    {
        "name": "ПИТКЭРН",
        "value": "PN"
    },
    {
        "name": "ПОЛЬША",
        "value": "PL"
    },
    {
        "name": "ПОРТУГАЛИЯ",
        "value": "PT"
    },
    {
        "name": "ПУЭРТО-РИКО",
        "value": "PR"
    },
    {
        "name": "КАТАР",
        "value": "QA"
    },
    {
        "name": "ВОССОЕДИНЕНИЕ",
        "value": "RE"
    },
    {
        "name": "РУМЫНИЯ",
        "value": "RO"
    },
    {
        "name": "РОССИЙСКАЯ ФЕДЕРАЦИЯ",
        "value": "RU"
    },
    {
        "name": "РУАНДА",
        "value": "RW"
    },
    {
        "name": "СВЯТАЯ ЕЛЕНА",
        "value": "SH"
    },
    {
        "name": "СЕНТ-КИТС И НЕВИС",
        "value": "KN"
    },
    {
        "name": "СЕНТ-ЛЮСИЯ",
        "value": "LC"
    },
    {
        "name": "СЕН-ПЬЕР И МИКЕЛЬОН",
        "value": "PM"
    },
    {
        "name": "СВЯТОЙ ВИНСЕНТ И ГРЕНАДИНЫ",
        "value": "VC"
    },
    {
        "name": "САМОА",
        "value": "WS"
    },
    {
        "name": "САН-МАРИНО",
        "value": "SM"
    },
    {
        "name": "САН-ТОМЕ И ПРИНСИПИ",
        "value": "ST"
    },
    {
        "name": "САУДОВСКАЯ АРАВИЯ",
        "value": "SA"
    },
    {
        "name": "СЕНЕГАЛ",
        "value": "SN"
    },
    {
        "name": "СЕРБИЯ И ЧЕРНОГОРИЯ",
        "value": "CS"
    },
    {
        "name": "СЕЙШЕЛЬСКИЕ ОСТРОВА",
        "value": "SC"
    },
    {
        "name": "СЬЕРРА-ЛЕОНЕ",
        "value": "SL"
    },
    {
        "name": "СИНГАПУР",
        "value": "SG"
    },
    {
        "name": "СЛОВАКИЯ",
        "value": "SK"
    },
    {
        "name": "СЛОВЕНИЯ",
        "value": "SI"
    },
    {
        "name": "СОЛОМОНОВЫ ОСТРОВА",
        "value": "SB"
    },
    {
        "name": "СОМАЛИ",
        "value": "SO"
    },
    {
        "name": "ЮЖНАЯ АФРИКА",
        "value": "ZA"
    },
    {
        "name": "ЮЖНАЯ ГРУЗИЯ И ЮЖНЫЙ СЭНДВИЧОВЫЙ ОСТРОВ",
        "value": "DS"
    },
    {
        "name": "ИСПАНИЯ",
        "value": "ES"
    },
    {
        "name": "ШРИ-ЛАНКА",
        "value": "LK"
    },
    {
        "name": "СУДАН",
        "value": "SD"
    },
    {
        "name": "СУРИНАМ",
        "value": "SR"
    },
    {
        "name": "ОСТРОВА ШВЕЙБАРД И ЯН-МАЙЕН",
        "value": "SJ"
    },
    {
        "name": "СВАЗИЛЕНД",
        "value": "SZ"
    },
    {
        "name": "ШВЕЦИЯ",
        "value": "SE"
    },
    {
        "name": "ШВЕЙЦАРИЯ",
        "value": "CH"
    },
    {
        "name": "СИРИЙСКАЯ АРАБСКАЯ РЕСПУБЛИКА",
        "value": "SY"
    },
    {
        "name": "ТАЙВАНЬ, КИТАЙ",
        "value": "TW"
    },
    {
        "name": "ТАДЖИКИСТАН",
        "value": "TJ"
    },
    {
        "name": "ТАНЗАНИЯ, ОБЪЕДИНЕННАЯ РЕСПУБЛИКА",
        "value": "TZ"
    },
    {
        "name": "ТАИЛАНД",
        "value": "TH"
    },
    {
        "name": "ТИМОР-ЛЕШТИ",
        "value": "TL"
    },
    {
        "name": "ИДТИ",
        "value": "TG"
    },
    {
        "name": "ТОКЕЛАУ",
        "value": "TK"
    },
    {
        "name": "ТОНГА",
        "value": "TO"
    },
    {
        "name": "ТРИНИДАД И ТОБАГО",
        "value": "TT"
    },
    {
        "name": "ТУНИС",
        "value": "TN"
    },
    {
        "name": "ИНДЕЙКА",
        "value": "TR"
    },
    {
        "name": "ТУРКМЕНИСТАН",
        "value": "TM"
    },
    {
        "name": "ОСТРОВА ТЕРКС И КАЙКОС",
        "value": "TC"
    },
    {
        "name": "ТУВАЛУ",
        "value": "TV"
    },
    {
        "name": "УГАНДА",
        "value": "UG"
    },
    {
        "name": "УКРАИНА",
        "value": "UA"
    },
    {
        "name": "ОБЪЕДИНЕННЫЕ АРАБСКИЕ ЭМИРАТЫ",
        "value": "AE"
    },
    {
        "name": "СОЕДИНЕННОЕ КОРОЛЕВСТВО",
        "value": "GB"
    },
    {
        "name": "СОЕДИНЕННЫЕ ШТАТЫ",
        "value": "US"
    },
    {
        "name": "ОТДАЛЕННЫЕ МАЛЫЕ ОСТРОВА СОЕДИНЕННЫХ ШТАТОВ",
        "value": "UM"
    },
    {
        "name": "УРУГВАЙ",
        "value": "UY"
    },
    {
        "name": "УЗБЕКИСТАН",
        "value": "UZ"
    },
    {
        "name": "ВАНУАТУ",
        "value": "VU"
    },
    {
        "name": "ВАТИКАН ГОРОД-ГОСУДАРСТВО (СВЯТОЙ ПРЕСТОЛ)",
        "value": "VA"
    },
    {
        "name": "ВЕНЕСУЭЛА",
        "value": "VE"
    },
    {
        "name": "ВЬЕТНАМ",
        "value": "VN"
    },
    {
        "name": "ВИРГИНСКИЕ ОСТРОВА (БРИТАНСКИЕ)",
        "value": "VG"
    },
    {
        "name": "ВИРГИНСКИЕ ОСТРОВА (США)",
        "value": "VI"
    },
    {
        "name": "ОСТРОВА УОЛЛИС И ФУТУНА",
        "value": "WF"
    },
    {
        "name": "ЗАПАДНАЯ САХАРА",
        "value": "EH"
    },
    {
        "name": "ЙЕМЕН",
        "value": "YE"
    },
    {
        "name": "ЗАМБИЯ",
        "value": "ZM"
    },
    {
        "name": "ЗИМБАБВЕ",
        "value": "ZW"
    }
]

export const countryStaticDataHK = [
    {
        "name": "奧克蘭群島",
        "value": "AX"
    },
    {
        "name": "阿富汗",
        "value": "AF"
    },
    {
        "name": "阿爾巴尼亞",
        "value": "AL"
    },
    {
        "name": "阿爾及利亞",
        "value": "DZ"
    },
    {
        "name": "美屬薩摩亞",
        "value": "AS"
    },
    {
        "name": "安道爾",
        "value": "AD"
    },
    {
        "name": "安哥拉",
        "value": "AO"
    },
    {
        "name": "安圭拉",
        "value": "AI"
    },
    {
        "name": "南極洲",
        "value": "AQ"
    },
    {
        "name": "安提瓜和巴布達",
        "value": "AG"
    },
    {
        "name": "阿根廷",
        "value": "AR"
    },
    {
        "name": "亞美尼亞",
        "value": "AM"
    },
    {
        "name": "阿魯巴",
        "value": "AW"
    },
    {
        "name": "澳大利亞",
        "value": "AU"
    },
    {
        "name": "奧地利",
        "value": "AT"
    },
    {
        "name": "阿塞拜疆",
        "value": "AZ"
    },
    {
        "name": "巴哈馬",
        "value": "BS"
    },
    {
        "name": "巴林",
        "value": "BH"
    },
    {
        "name": "孟加拉國",
        "value": "BD"
    },
    {
        "name": "巴巴多斯",
        "value": "BB"
    },
    {
        "name": "白俄羅斯",
        "value": "BY"
    },
    {
        "name": "比利時",
        "value": "BE"
    },
    {
        "name": "伯利茲",
        "value": "BZ"
    },
    {
        "name": "貝寧",
        "value": "BJ"
    },
    {
        "name": "百慕大",
        "value": "BM"
    },
    {
        "name": "不丹",
        "value": "BT"
    },
    {
        "name": "玻利維亞",
        "value": "BO"
    },
    {
        "name": "波斯尼亞和黑塞哥維那",
        "value": "BA"
    },
    {
        "name": "博茨瓦納",
        "value": "BW"
    },
    {
        "name": "布韋島",
        "value": "BV"
    },
    {
        "name": "巴西",
        "value": "BR"
    },
    {
        "name": "英屬印度洋領地",
        "value": "IO"
    },
    {
        "name": "文萊達魯薩蘭國",
        "value": "BN"
    },
    {
        "name": "保加利亞",
        "value": "BG"
    },
    {
        "name": "布基納法索",
        "value": "BF"
    },
    {
        "name": "布隆迪",
        "value": "BI"
    },
    {
        "name": "柬埔寨",
        "value": "KH"
    },
    {
        "name": "喀麥隆",
        "value": "CM"
    },
    {
        "name": "加拿大",
        "value": "CA"
    },
    {
        "name": "佛得角",
        "value": "CV"
    },
    {
        "name": "開曼群島",
        "value": "KY"
    },
    {
        "name": "中非共和國",
        "value": "CF"
    },
    {
        "name": "乍得",
        "value": "TD"
    },
    {
        "name": "智利",
        "value": "CL"
    },
    {
        "name": "中國",
        "value": "CN"
    },
    {
        "name": "聖誕島",
        "value": "CX"
    },
    {
        "name": "科科斯（基林）群島",
        "value": "CC"
    },
    {
        "name": "哥倫比亞",
        "value": "CO"
    },
    {
        "name": "科摩羅",
        "value": "KM"
    },
    {
        "name": "剛果民主共和國",
        "value": "CD"
    },
    {
        "name": "剛果共和國",
        "value": "CG"
    },
    {
        "name": "庫克群島",
        "value": "CK"
    },
    {
        "name": "哥斯達黎加",
        "value": "CR"
    },
    {
        "name": "科特迪瓦",
        "value": "CI"
    },
    {
        "name": "克羅地亞",
        "value": "HR"
    },
    {
        "name": "古巴",
        "value": "CU"
    },
    {
        "name": "塞浦路斯",
        "value": "CY"
    },
    {
        "name": "捷克共和國",
        "value": "CZ"
    },
    {
        "name": "丹麥",
        "value": "DK"
    },
    {
        "name": "吉布提",
        "value": "DJ"
    },
    {
        "name": "多米尼克",
        "value": "DM"
    },
    {
        "name": "多明尼加共和國",
        "value": "DO"
    },
    {
        "name": "厄瓜多爾",
        "value": "EC"
    },
    {
        "name": "埃及",
        "value": "EG"
    },
    {
        "name": "薩爾瓦多",
        "value": "SV"
    },
    {
        "name": "赤道幾內亞",
        "value": "GQ"
    },
    {
        "name": "厄立特里亞",
        "value": "ER"
    },
    {
        "name": "愛沙尼亞",
        "value": "EE"
    },
    {
        "name": "埃塞俄比亞",
        "value": "ET"
    },
    {
        "name": "福克蘭群島（馬爾維納斯）",
        "value": "FK"
    },
    {
        "name": "法羅群島",
        "value": "FO"
    },
    {
        "name": "斐濟",
        "value": "FJ"
    },
    {
        "name": "芬蘭",
        "value": "FI"
    },
    {
        "name": "法國",
        "value": "FR"
    },
    {
        "name": "法屬圭亞那",
        "value": "GF"
    },
    {
        "name": "法屬波利尼西亞",
        "value": "PF"
    },
    {
        "name": "法屬南部領地",
        "value": "TF"
    },
    {
        "name": "加蓬",
        "value": "GA"
    },
    {
        "name": "岡比亞",
        "value": "GM"
    },
    {
        "name": "喬治亞州",
        "value": "GE"
    },
    {
        "name": "德國",
        "value": "DE"
    },
    {
        "name": "加納",
        "value": "GH"
    },
    {
        "name": "直布羅陀",
        "value": "GI"
    },
    {
        "name": "希臘",
        "value": "GR"
    },
    {
        "name": "格陵蘭",
        "value": "GL"
    },
    {
        "name": "格林納達",
        "value": "GD"
    },
    {
        "name": "瓜德羅普",
        "value": "GP"
    },
    {
        "name": "關島",
        "value": "GU"
    },
    {
        "name": "危地馬拉",
        "value": "GT"
    },
    {
        "name": "幾內亞",
        "value": "GN"
    },
    {
        "name": "幾內亞比紹",
        "value": "GW"
    },
    {
        "name": "圭亞那",
        "value": "GY"
    },
    {
        "name": "海地",
        "value": "HT"
    },
    {
        "name": "聽到和 MC 唐納德島",
        "value": "HM"
    },
    {
        "name": "洪都拉斯",
        "value": "HN"
    },
    {
        "name": "中國香港",
        "value": "HK"
    },
    {
        "name": "匈牙利",
        "value": "HU"
    },
    {
        "name": "冰島",
        "value": "IS"
    },
    {
        "name": "印度",
        "value": "IN"
    },
    {
        "name": "印度尼西亞",
        "value": "ID"
    },
    {
        "name": "伊朗（伊斯蘭共和國）",
        "value": "IR"
    },
    {
        "name": "伊拉克",
        "value": "IQ"
    },
    {
        "name": "愛爾蘭",
        "value": "IE"
    },
    {
        "name": "以色列",
        "value": "IL"
    },
    {
        "name": "意大利",
        "value": "IT"
    },
    {
        "name": "牙買加",
        "value": "JM"
    },
    {
        "name": "日本",
        "value": "JP"
    },
    {
        "name": "約旦",
        "value": "JO"
    },
    {
        "name": "哈薩克斯坦",
        "value": "KZ"
    },
    {
        "name": "肯尼亞",
        "value": "KE"
    },
    {
        "name": "基里巴斯",
        "value": "KI"
    },
    {
        "name": "朝鮮民主主義人民共和國",
        "value": "KP"
    },
    {
        "name": "大韓民國",
        "value": "KR"
    },
    {
        "name": "科威特",
        "value": "KW"
    },
    {
        "name": "吉爾吉斯斯坦",
        "value": "KG"
    },
    {
        "name": "老撾人民民主共和國",
        "value": "LA"
    },
    {
        "name": "拉脫維亞",
        "value": "LV"
    },
    {
        "name": "黎巴嫩",
        "value": "LB"
    },
    {
        "name": "萊索托",
        "value": "LS"
    },
    {
        "name": "利比里亞",
        "value": "LR"
    },
    {
        "name": "阿拉伯利比亞民眾國",
        "value": "LY"
    },
    {
        "name": "列支敦士登",
        "value": "LI"
    },
    {
        "name": "立陶宛",
        "value": "LT"
    },
    {
        "name": "盧森堡",
        "value": "LU"
    },
    {
        "name": "中國澳門",
        "value": "MO"
    },
    {
        "name": "馬其頓，前南斯拉夫共和國",
        "value": "MK"
    },
    {
        "name": "馬達加斯加",
        "value": "MG"
    },
    {
        "name": "馬拉維",
        "value": "MW"
    },
    {
        "name": "馬來西亞",
        "value": "MY"
    },
    {
        "name": "馬爾代夫",
        "value": "MV"
    },
    {
        "name": "馬里",
        "value": "ML"
    },
    {
        "name": "馬耳他",
        "value": "MT"
    },
    {
        "name": "馬紹爾群島",
        "value": "MH"
    },
    {
        "name": "馬提尼克島",
        "value": "MQ"
    },
    {
        "name": "毛里塔尼亞",
        "value": "MR"
    },
    {
        "name": "毛里求斯",
        "value": "MU"
    },
    {
        "name": "馬約特",
        "value": "YT"
    },
    {
        "name": "墨西哥",
        "value": "MX"
    },
    {
        "name": "密克羅尼西亞聯邦",
        "value": "FM"
    },
    {
        "name": "摩爾多瓦共和國",
        "value": "MD"
    },
    {
        "name": "摩納哥",
        "value": "MC"
    },
    {
        "name": "蒙古",
        "value": "MN"
    },
    {
        "name": "蒙特塞拉特",
        "value": "MS"
    },
    {
        "name": "摩洛哥",
        "value": "MA"
    },
    {
        "name": "莫桑比克",
        "value": "MZ"
    },
    {
        "name": "緬甸",
        "value": "MM"
    },
    {
        "name": "納米比亞",
        "value": "NA"
    },
    {
        "name": "瑙魯",
        "value": "NR"
    },
    {
        "name": "尼泊爾",
        "value": "NP"
    },
    {
        "name": "荷蘭",
        "value": "NL"
    },
    {
        "name": "荷屬安的列斯",
        "value": "AN"
    },
    {
        "name": "新喀裡多尼亞",
        "value": "NC"
    },
    {
        "name": "新西蘭",
        "value": "NZ"
    },
    {
        "name": "尼加拉瓜",
        "value": "NI"
    },
    {
        "name": "尼日爾",
        "value": "NE"
    },
    {
        "name": "尼日利亞",
        "value": "NG"
    },
    {
        "name": "紐埃",
        "value": "NU"
    },
    {
        "name": "諾福克島",
        "value": "NF"
    },
    {
        "name": "北馬里亞納群島",
        "value": "MP"
    },
    {
        "name": "挪威",
        "value": "NO"
    },
    {
        "name": "阿曼",
        "value": "OM"
    },
    {
        "name": "巴基斯坦",
        "value": "PK"
    },
    {
        "name": "帕勞",
        "value": "PW"
    },
    {
        "name": "巴勒斯坦領土",
        "value": "PS"
    },
    {
        "name": "巴拿馬",
        "value": "PA"
    },
    {
        "name": "巴布亞新幾內亞",
        "value": "PG"
    },
    {
        "name": "巴拉圭",
        "value": "PY"
    },
    {
        "name": "秘魯",
        "value": "PE"
    },
    {
        "name": "菲律賓",
        "value": "PH"
    },
    {
        "name": "皮特凱恩",
        "value": "PN"
    },
    {
        "name": "波蘭",
        "value": "PL"
    },
    {
        "name": "葡萄牙",
        "value": "PT"
    },
    {
        "name": "波多黎各",
        "value": "PR"
    },
    {
        "name": "卡塔爾",
        "value": "QA"
    },
    {
        "name": "團圓",
        "value": "RE"
    },
    {
        "name": "羅馬尼亞",
        "value": "RO"
    },
    {
        "name": "俄羅斯聯邦",
        "value": "RU"
    },
    {
        "name": "盧旺達",
        "value": "RW"
    },
    {
        "name": "聖赫勒拿",
        "value": "SH"
    },
    {
        "name": "聖基茨和尼維斯",
        "value": "KN"
    },
    {
        "name": "聖盧西亞",
        "value": "LC"
    },
    {
        "name": "聖皮埃爾和密克隆",
        "value": "PM"
    },
    {
        "name": "聖文森特和格林納丁斯",
        "value": "VC"
    },
    {
        "name": "薩摩亞",
        "value": "WS"
    },
    {
        "name": "聖馬力諾",
        "value": "SM"
    },
    {
        "name": "聖多美和普林西比",
        "value": "ST"
    },
    {
        "name": "沙特阿拉伯",
        "value": "SA"
    },
    {
        "name": "塞內加爾",
        "value": "SN"
    },
    {
        "name": "塞爾維亞和黑山",
        "value": "CS"
    },
    {
        "name": "塞舌爾",
        "value": "SC"
    },
    {
        "name": "塞拉利昂",
        "value": "SL"
    },
    {
        "name": "新加坡",
        "value": "SG"
    },
    {
        "name": "斯洛伐克",
        "value": "SK"
    },
    {
        "name": "斯洛文尼亞",
        "value": "SI"
    },
    {
        "name": "所羅門群島",
        "value": "SB"
    },
    {
        "name": "索馬里",
        "value": "SO"
    },
    {
        "name": "南非",
        "value": "ZA"
    },
    {
        "name": "南喬治亞州和南三明治島",
        "value": "DS"
    },
    {
        "name": "西班牙",
        "value": "ES"
    },
    {
        "name": "斯里蘭卡",
        "value": "LK"
    },
    {
        "name": "蘇丹",
        "value": "SD"
    },
    {
        "name": "蘇里南",
        "value": "SR"
    },
    {
        "name": "斯瓦爾巴群島和揚馬延群島",
        "value": "SJ"
    },
    {
        "name": "斯威士蘭",
        "value": "SZ"
    },
    {
        "name": "瑞典",
        "value": "SE"
    },
    {
        "name": "瑞士",
        "value": "CH"
    },
    {
        "name": "阿拉伯敘利亞共和國",
        "value": "SY"
    },
    {
        "name": "中國台灣",
        "value": "TW"
    },
    {
        "name": "塔吉克斯坦",
        "value": "TJ"
    },
    {
        "name": "坦桑尼亞聯合共和國",
        "value": "TZ"
    },
    {
        "name": "泰國",
        "value": "TH"
    },
    {
        "name": "東帝汶",
        "value": "TL"
    },
    {
        "name": "多哥",
        "value": "TG"
    },
    {
        "name": "托克勞",
        "value": "TK"
    },
    {
        "name": "湯加",
        "value": "TO"
    },
    {
        "name": "特立尼達和多巴哥",
        "value": "TT"
    },
    {
        "name": "突尼斯",
        "value": "TN"
    },
    {
        "name": "火雞",
        "value": "TR"
    },
    {
        "name": "土庫曼斯坦",
        "value": "TM"
    },
    {
        "name": "特克斯和凱科斯群島",
        "value": "TC"
    },
    {
        "name": "圖瓦盧",
        "value": "TV"
    },
    {
        "name": "烏干達",
        "value": "UG"
    },
    {
        "name": "烏克蘭",
        "value": "UA"
    },
    {
        "name": "阿拉伯聯合酋長國",
        "value": "AE"
    },
    {
        "name": "英國",
        "value": "GB"
    },
    {
        "name": "美國",
        "value": "US"
    },
    {
        "name": "美國離島小島",
        "value": "UM"
    },
    {
        "name": "烏拉圭",
        "value": "UY"
    },
    {
        "name": "烏茲別克斯坦",
        "value": "UZ"
    },
    {
        "name": "瓦努阿圖",
        "value": "VU"
    },
    {
        "name": "梵蒂岡城國（教廷）",
        "value": "VA"
    },
    {
        "name": "委內瑞拉",
        "value": "VE"
    },
    {
        "name": "越南",
        "value": "VN"
    },
    {
        "name": "維爾京群島（英國）",
        "value": "VG"
    },
    {
        "name": "維爾京群島（美國）",
        "value": "VI"
    },
    {
        "name": "瓦利斯和富圖納群島",
        "value": "WF"
    },
    {
        "name": "西撒哈拉",
        "value": "EH"
    },
    {
        "name": "也門",
        "value": "YE"
    },
    {
        "name": "贊比亞",
        "value": "ZM"
    },
    {
        "name": "津巴布韋",
        "value": "ZW"
    }
]

export const countryStaticDataEN = [
    {
        "name": "Aaland islands",
        "value": "AX"
    },
    {
        "name": "Afghanistan",
        "value": "AF"
    },
    {
        "name": "Albania",
        "value": "AL"
    },
    {
        "name": "Algeria",
        "value": "DZ"
    },
    {
        "name": "American samoa",
        "value": "AS"
    },
    {
        "name": "Andorra",
        "value": "AD"
    },
    {
        "name": "Angola",
        "value": "AO"
    },
    {
        "name": "Anguilla",
        "value": "AI"
    },
    {
        "name": "Antarctica",
        "value": "AQ"
    },
    {
        "name": "Antigua and barbuda",
        "value": "AG"
    },
    {
        "name": "Argentina",
        "value": "AR"
    },
    {
        "name": "Armenia",
        "value": "AM"
    },
    {
        "name": "Aruba",
        "value": "AW"
    },
    {
        "name": "Australia",
        "value": "AU"
    },
    {
        "name": "Austria",
        "value": "AT"
    },
    {
        "name": "Azerbaijan",
        "value": "AZ"
    },
    {
        "name": "Bahamas",
        "value": "BS"
    },
    {
        "name": "Bahrain",
        "value": "BH"
    },
    {
        "name": "Bangladesh",
        "value": "BD"
    },
    {
        "name": "Barbados",
        "value": "BB"
    },
    {
        "name": "Belarus",
        "value": "BY"
    },
    {
        "name": "Belgium",
        "value": "BE"
    },
    {
        "name": "Belize",
        "value": "BZ"
    },
    {
        "name": "Benin",
        "value": "BJ"
    },
    {
        "name": "Bermuda",
        "value": "BM"
    },
    {
        "name": "Bhutan",
        "value": "BT"
    },
    {
        "name": "Bolivia",
        "value": "BO"
    },
    {
        "name": "Bosnia and herzegowina",
        "value": "BA"
    },
    {
        "name": "Botswana",
        "value": "BW"
    },
    {
        "name": "Bouvet island",
        "value": "BV"
    },
    {
        "name": "Brazil",
        "value": "BR"
    },
    {
        "name": "British indian ocean territory",
        "value": "IO"
    },
    {
        "name": "Brunei darussalam",
        "value": "BN"
    },
    {
        "name": "Bulgaria",
        "value": "BG"
    },
    {
        "name": "Burkina faso",
        "value": "BF"
    },
    {
        "name": "Burundi",
        "value": "BI"
    },
    {
        "name": "Cambodia",
        "value": "KH"
    },
    {
        "name": "Cameroon",
        "value": "CM"
    },
    {
        "name": "Canada",
        "value": "CA"
    },
    {
        "name": "Cape verde",
        "value": "CV"
    },
    {
        "name": "Cayman islands",
        "value": "KY"
    },
    {
        "name": "Central african republic",
        "value": "CF"
    },
    {
        "name": "Chad",
        "value": "TD"
    },
    {
        "name": "Chile",
        "value": "CL"
    },
    {
        "name": "China",
        "value": "CN"
    },
    {
        "name": "Christmas island",
        "value": "CX"
    },
    {
        "name": "Cocos (keeling) islands",
        "value": "CC"
    },
    {
        "name": "Colombia",
        "value": "CO"
    },
    {
        "name": "Comoros",
        "value": "KM"
    },
    {
        "name": "Congo, democratic republic of",
        "value": "CD"
    },
    {
        "name": "Congo, republic of",
        "value": "CG"
    },
    {
        "name": "Cook islands",
        "value": "CK"
    },
    {
        "name": "Costa rica",
        "value": "CR"
    },
    {
        "name": "Cote d'ivoire",
        "value": "CI"
    },
    {
        "name": "Croatia",
        "value": "HR"
    },
    {
        "name": "Cuba",
        "value": "CU"
    },
    {
        "name": "Cyprus",
        "value": "CY"
    },
    {
        "name": "Czech republic",
        "value": "CZ"
    },
    {
        "name": "Denmark",
        "value": "DK"
    },
    {
        "name": "Djibouti",
        "value": "DJ"
    },
    {
        "name": "Dominica",
        "value": "DM"
    },
    {
        "name": "Dominican republic",
        "value": "DO"
    },
    {
        "name": "Ecuador",
        "value": "EC"
    },
    {
        "name": "Egypt",
        "value": "EG"
    },
    {
        "name": "El salvador",
        "value": "SV"
    },
    {
        "name": "Equatorial guinea",
        "value": "GQ"
    },
    {
        "name": "Eritrea",
        "value": "ER"
    },
    {
        "name": "Estonia",
        "value": "EE"
    },
    {
        "name": "Ethiopia",
        "value": "ET"
    },
    {
        "name": "Falkland islands (malvinas)",
        "value": "FK"
    },
    {
        "name": "Faroe islands",
        "value": "FO"
    },
    {
        "name": "Fiji",
        "value": "FJ"
    },
    {
        "name": "Finland",
        "value": "FI"
    },
    {
        "name": "France",
        "value": "FR"
    },
    {
        "name": "French guiana",
        "value": "GF"
    },
    {
        "name": "French polynesia",
        "value": "PF"
    },
    {
        "name": "French southern territories",
        "value": "TF"
    },
    {
        "name": "Gabon",
        "value": "GA"
    },
    {
        "name": "Gambia",
        "value": "GM"
    },
    {
        "name": "Georgia",
        "value": "GE"
    },
    {
        "name": "Germany",
        "value": "DE"
    },
    {
        "name": "Ghana",
        "value": "GH"
    },
    {
        "name": "Gibraltar",
        "value": "GI"
    },
    {
        "name": "Greece",
        "value": "GR"
    },
    {
        "name": "Greenland",
        "value": "GL"
    },
    {
        "name": "Grenada",
        "value": "GD"
    },
    {
        "name": "Guadeloupe",
        "value": "GP"
    },
    {
        "name": "Guam",
        "value": "GU"
    },
    {
        "name": "Guatemala",
        "value": "GT"
    },
    {
        "name": "Guinea",
        "value": "GN"
    },
    {
        "name": "Guinea-bissau",
        "value": "GW"
    },
    {
        "name": "Guyana",
        "value": "GY"
    },
    {
        "name": "Haiti",
        "value": "HT"
    },
    {
        "name": "Heard and mc donald islands",
        "value": "HM"
    },
    {
        "name": "Honduras",
        "value": "HN"
    },
    {
        "name": "Hong kong, china",
        "value": "HK"
    },
    {
        "name": "Hungary",
        "value": "HU"
    },
    {
        "name": "Iceland",
        "value": "IS"
    },
    {
        "name": "India",
        "value": "IN"
    },
    {
        "name": "Indonesia",
        "value": "ID"
    },
    {
        "name": "Iran (islamic republic of)",
        "value": "IR"
    },
    {
        "name": "Iraq",
        "value": "IQ"
    },
    {
        "name": "Ireland",
        "value": "IE"
    },
    {
        "name": "Israel",
        "value": "IL"
    },
    {
        "name": "Italy",
        "value": "IT"
    },
    {
        "name": "Jamaica",
        "value": "JM"
    },
    {
        "name": "Japan",
        "value": "JP"
    },
    {
        "name": "Jordan",
        "value": "JO"
    },
    {
        "name": "Kazakhstan",
        "value": "KZ"
    },
    {
        "name": "Kenya",
        "value": "KE"
    },
    {
        "name": "Kiribati",
        "value": "KI"
    },
    {
        "name": "Korea, democratic people's republic of",
        "value": "KP"
    },
    {
        "name": "Korea, republic of",
        "value": "KR"
    },
    {
        "name": "Kuwait",
        "value": "KW"
    },
    {
        "name": "Kyrgyzstan",
        "value": "KG"
    },
    {
        "name": "Lao people's democratic republic",
        "value": "LA"
    },
    {
        "name": "Latvia",
        "value": "LV"
    },
    {
        "name": "Lebanon",
        "value": "LB"
    },
    {
        "name": "Lesotho",
        "value": "LS"
    },
    {
        "name": "Liberia",
        "value": "LR"
    },
    {
        "name": "Libyan arab jamahiriya",
        "value": "LY"
    },
    {
        "name": "Liechtenstein",
        "value": "LI"
    },
    {
        "name": "Lithuania",
        "value": "LT"
    },
    {
        "name": "Luxembourg",
        "value": "LU"
    },
    {
        "name": "Macau, china",
        "value": "MO"
    },
    {
        "name": "Macedonia, the former yugoslav republic of",
        "value": "MK"
    },
    {
        "name": "Madagascar",
        "value": "MG"
    },
    {
        "name": "Malawi",
        "value": "MW"
    },
    {
        "name": "Malaysia",
        "value": "MY"
    },
    {
        "name": "Maldives",
        "value": "MV"
    },
    {
        "name": "Mali",
        "value": "ML"
    },
    {
        "name": "Malta",
        "value": "MT"
    },
    {
        "name": "Marshall islands",
        "value": "MH"
    },
    {
        "name": "Martinique",
        "value": "MQ"
    },
    {
        "name": "Mauritania",
        "value": "MR"
    },
    {
        "name": "Mauritius",
        "value": "MU"
    },
    {
        "name": "Mayotte",
        "value": "YT"
    },
    {
        "name": "Mexico",
        "value": "MX"
    },
    {
        "name": "Micronesia, federated states of",
        "value": "FM"
    },
    {
        "name": "Moldova, republic of",
        "value": "MD"
    },
    {
        "name": "Monaco",
        "value": "MC"
    },
    {
        "name": "Mongolia",
        "value": "MN"
    },
    {
        "name": "Montserrat",
        "value": "MS"
    },
    {
        "name": "Morocco",
        "value": "MA"
    },
    {
        "name": "Mozambique",
        "value": "MZ"
    },
    {
        "name": "Myanmar",
        "value": "MM"
    },
    {
        "name": "Namibia",
        "value": "NA"
    },
    {
        "name": "Nauru",
        "value": "NR"
    },
    {
        "name": "Nepal",
        "value": "NP"
    },
    {
        "name": "Netherlands",
        "value": "NL"
    },
    {
        "name": "Netherlands antilles",
        "value": "AN"
    },
    {
        "name": "New caledonia",
        "value": "NC"
    },
    {
        "name": "New zealand",
        "value": "NZ"
    },
    {
        "name": "Nicaragua",
        "value": "NI"
    },
    {
        "name": "Niger",
        "value": "NE"
    },
    {
        "name": "Nigeria",
        "value": "NG"
    },
    {
        "name": "Niue",
        "value": "NU"
    },
    {
        "name": "Norfolk island",
        "value": "NF"
    },
    {
        "name": "Northern mariana islands",
        "value": "MP"
    },
    {
        "name": "Norway",
        "value": "NO"
    },
    {
        "name": "Oman",
        "value": "OM"
    },
    {
        "name": "Pakistan",
        "value": "PK"
    },
    {
        "name": "Palau",
        "value": "PW"
    },
    {
        "name": "Palestinian territory",
        "value": "PS"
    },
    {
        "name": "Panama",
        "value": "PA"
    },
    {
        "name": "Papua new guinea",
        "value": "PG"
    },
    {
        "name": "Paraguay",
        "value": "PY"
    },
    {
        "name": "Peru",
        "value": "PE"
    },
    {
        "name": "Philippines",
        "value": "PH"
    },
    {
        "name": "Pitcairn",
        "value": "PN"
    },
    {
        "name": "Poland",
        "value": "PL"
    },
    {
        "name": "Portugal",
        "value": "PT"
    },
    {
        "name": "Puerto rico",
        "value": "PR"
    },
    {
        "name": "Qatar",
        "value": "QA"
    },
    {
        "name": "Reunion",
        "value": "RE"
    },
    {
        "name": "Romania",
        "value": "RO"
    },
    {
        "name": "Russian federation",
        "value": "RU"
    },
    {
        "name": "Rwanda",
        "value": "RW"
    },
    {
        "name": "Saint helena",
        "value": "SH"
    },
    {
        "name": "Saint kitts and nevis",
        "value": "KN"
    },
    {
        "name": "Saint lucia",
        "value": "LC"
    },
    {
        "name": "Saint pierre and miquelon",
        "value": "PM"
    },
    {
        "name": "Saint vincent and the grenadines",
        "value": "VC"
    },
    {
        "name": "Samoa",
        "value": "WS"
    },
    {
        "name": "San marino",
        "value": "SM"
    },
    {
        "name": "Sao tome and principe",
        "value": "ST"
    },
    {
        "name": "Saudi arabia",
        "value": "SA"
    },
    {
        "name": "Senegal",
        "value": "SN"
    },
    {
        "name": "Serbia and montenegro",
        "value": "CS"
    },
    {
        "name": "Seychelles",
        "value": "SC"
    },
    {
        "name": "Sierra leone",
        "value": "SL"
    },
    {
        "name": "Singapore",
        "value": "SG"
    },
    {
        "name": "Slovakia",
        "value": "SK"
    },
    {
        "name": "Slovenia",
        "value": "SI"
    },
    {
        "name": "Solomon islands",
        "value": "SB"
    },
    {
        "name": "Somalia",
        "value": "SO"
    },
    {
        "name": "South africa",
        "value": "ZA"
    },
    {
        "name": "South georgia and the south sandwich islan",
        "value": "DS"
    },
    {
        "name": "Spain",
        "value": "ES"
    },
    {
        "name": "Sri lanka",
        "value": "LK"
    },
    {
        "name": "Sudan",
        "value": "SD"
    },
    {
        "name": "Suriname",
        "value": "SR"
    },
    {
        "name": "Svalbard and jan mayen islands",
        "value": "SJ"
    },
    {
        "name": "Swaziland",
        "value": "SZ"
    },
    {
        "name": "Sweden",
        "value": "SE"
    },
    {
        "name": "Switzerland",
        "value": "CH"
    },
    {
        "name": "Syrian arab republic",
        "value": "SY"
    },
    {
        "name": "Taiwan, china",
        "value": "TW"
    },
    {
        "name": "Tajikistan",
        "value": "TJ"
    },
    {
        "name": "Tanzania, united republic of",
        "value": "TZ"
    },
    {
        "name": "Thailand",
        "value": "TH"
    },
    {
        "name": "Timor-leste",
        "value": "TL"
    },
    {
        "name": "Togo",
        "value": "TG"
    },
    {
        "name": "Tokelau",
        "value": "TK"
    },
    {
        "name": "Tonga",
        "value": "TO"
    },
    {
        "name": "Trinidad and tobago",
        "value": "TT"
    },
    {
        "name": "Tunisia",
        "value": "TN"
    },
    {
        "name": "Turkey",
        "value": "TR"
    },
    {
        "name": "Turkmenistan",
        "value": "TM"
    },
    {
        "name": "Turks and caicos islands",
        "value": "TC"
    },
    {
        "name": "Tuvalu",
        "value": "TV"
    },
    {
        "name": "Uganda",
        "value": "UG"
    },
    {
        "name": "Ukraine",
        "value": "UA"
    },
    {
        "name": "United arab emirates",
        "value": "AE"
    },
    {
        "name": "United kingdom",
        "value": "GB"
    },
    {
        "name": "United states",
        "value": "US"
    },
    {
        "name": "United states minor outlying islands",
        "value": "UM"
    },
    {
        "name": "Uruguay",
        "value": "UY"
    },
    {
        "name": "Uzbekistan",
        "value": "UZ"
    },
    {
        "name": "Vanuatu",
        "value": "VU"
    },
    {
        "name": "Vatican city state (holy see)",
        "value": "VA"
    },
    {
        "name": "Venezuela",
        "value": "VE"
    },
    {
        "name": "Viet nam",
        "value": "VN"
    },
    {
        "name": "Virgin islands (british)",
        "value": "VG"
    },
    {
        "name": "Virgin islands (u.s.)",
        "value": "VI"
    },
    {
        "name": "Wallis and futuna islands",
        "value": "WF"
    },
    {
        "name": "Western sahara",
        "value": "EH"
    },
    {
        "name": "Yemen",
        "value": "YE"
    },
    {
        "name": "Zambia",
        "value": "ZM"
    },
    {
        "name": "Zimbabwe",
        "value": "ZW"
    }
]


export const countryStaticData = [
    {
        "name": "Aaland islands",
        "value": "Aaland islands"
    },
    {
        "name": "Afghanistan",
        "value": "Afghanistan"
    },
    {
        "name": "Albania",
        "value": "Albania"
    },
    {
        "name": "Algeria",
        "value": "Algeria"
    },
    {
        "name": "American samoa",
        "value": "American samoa"
    },
    {
        "name": "Andorra",
        "value": "Andorra"
    },
    {
        "name": "Angola",
        "value": "Angola"
    },
    {
        "name": "Anguilla",
        "value": "Anguilla"
    },
    {
        "name": "Antarctica",
        "value": "Antarctica"
    },
    {
        "name": "Antigua and barbuda",
        "value": "Antigua and barbuda"
    },
    {
        "name": "Argentina",
        "value": "Argentina"
    },
    {
        "name": "Armenia",
        "value": "Armenia"
    },
    {
        "name": "Aruba",
        "value": "Aruba"
    },
    {
        "name": "Australia",
        "value": "Australia"
    },
    {
        "name": "Austria",
        "value": "Austria"
    },
    {
        "name": "Azerbaijan",
        "value": "Azerbaijan"
    },
    {
        "name": "Bahamas",
        "value": "Bahamas"
    },
    {
        "name": "Bahrain",
        "value": "Bahrain"
    },
    {
        "name": "Bangladesh",
        "value": "Bangladesh"
    },
    {
        "name": "Barbados",
        "value": "Barbados"
    },
    {
        "name": "Belarus",
        "value": "Belarus"
    },
    {
        "name": "Belgium",
        "value": "Belgium"
    },
    {
        "name": "Belize",
        "value": "Belize"
    },
    {
        "name": "Benin",
        "value": "Benin"
    },
    {
        "name": "Bermuda",
        "value": "Bermuda"
    },
    {
        "name": "Bhutan",
        "value": "Bhutan"
    },
    {
        "name": "Bolivia",
        "value": "Bolivia"
    },
    {
        "name": "Bosnia and herzegowina",
        "value": "Bosnia and herzegowina"
    },
    {
        "name": "Botswana",
        "value": "Botswana"
    },
    {
        "name": "Bouvet island",
        "value": "Bouvet island"
    },
    {
        "name": "Brazil",
        "value": "Brazil"
    },
    {
        "name": "British indian ocean territory",
        "value": "British indian ocean territory"
    },
    {
        "name": "Brunei darussalam",
        "value": "Brunei darussalam"
    },
    {
        "name": "Bulgaria",
        "value": "Bulgaria"
    },
    {
        "name": "Burkina faso",
        "value": "Burkina faso"
    },
    {
        "name": "Burundi",
        "value": "Burundi"
    },
    {
        "name": "Cambodia",
        "value": "Cambodia"
    },
    {
        "name": "Cameroon",
        "value": "Cameroon"
    },
    {
        "name": "Canada",
        "value": "Canada"
    },
    {
        "name": "Cape verde",
        "value": "Cape verde"
    },
    {
        "name": "Cayman islands",
        "value": "Cayman islands"
    },
    {
        "name": "Central african republic",
        "value": "Central african republic"
    },
    {
        "name": "Chad",
        "value": "Chad"
    },
    {
        "name": "Chile",
        "value": "Chile"
    },
    {
        "name": "China",
        "value": "China"
    },
    {
        "name": "Christmas island",
        "value": "Christmas island"
    },
    {
        "name": "Cocos (keeling) islands",
        "value": "Cocos (keeling) islands"
    },
    {
        "name": "Colombia",
        "value": "Colombia"
    },
    {
        "name": "Comoros",
        "value": "Comoros"
    },
    {
        "name": "Congo, democratic republic of",
        "value": "Congo, democratic republic of"
    },
    {
        "name": "Congo, republic of",
        "value": "Congo, republic of"
    },
    {
        "name": "Cook islands",
        "value": "Cook islands"
    },
    {
        "name": "Costa rica",
        "value": "Costa rica"
    },
    {
        "name": "Cote d'ivoire",
        "value": "Cote d'ivoire"
    },
    {
        "name": "Croatia",
        "value": "Croatia"
    },
    {
        "name": "Cuba",
        "value": "Cuba"
    },
    {
        "name": "Cyprus",
        "value": "Cyprus"
    },
    {
        "name": "Czech republic",
        "value": "Czech republic"
    },
    {
        "name": "Denmark",
        "value": "Denmark"
    },
    {
        "name": "Djibouti",
        "value": "Djibouti"
    },
    {
        "name": "Dominica",
        "value": "Dominica"
    },
    {
        "name": "Dominican republic",
        "value": "Dominican republic"
    },
    {
        "name": "Ecuador",
        "value": "Ecuador"
    },
    {
        "name": "Egypt",
        "value": "Egypt"
    },
    {
        "name": "El salvador",
        "value": "El salvador"
    },
    {
        "name": "Equatorial guinea",
        "value": "Equatorial guinea"
    },
    {
        "name": "Eritrea",
        "value": "Eritrea"
    },
    {
        "name": "Estonia",
        "value": "Estonia"
    },
    {
        "name": "Ethiopia",
        "value": "Ethiopia"
    },
    {
        "name": "Falkland islands (malvinas)",
        "value": "Falkland islands (malvinas)"
    },
    {
        "name": "Faroe islands",
        "value": "Faroe islands"
    },
    {
        "name": "Fiji",
        "value": "Fiji"
    },
    {
        "name": "Finland",
        "value": "Finland"
    },
    {
        "name": "France",
        "value": "France"
    },
    {
        "name": "French guiana",
        "value": "French guiana"
    },
    {
        "name": "French polynesia",
        "value": "French polynesia"
    },
    {
        "name": "French southern territories",
        "value": "French southern territories"
    },
    {
        "name": "Gabon",
        "value": "Gabon"
    },
    {
        "name": "Gambia",
        "value": "Gambia"
    },
    {
        "name": "Georgia",
        "value": "Georgia"
    },
    {
        "name": "Germany",
        "value": "Germany"
    },
    {
        "name": "Ghana",
        "value": "Ghana"
    },
    {
        "name": "Gibraltar",
        "value": "Gibraltar"
    },
    {
        "name": "Greece",
        "value": "Greece"
    },
    {
        "name": "Greenland",
        "value": "Greenland"
    },
    {
        "name": "Grenada",
        "value": "Grenada"
    },
    {
        "name": "Guadeloupe",
        "value": "Guadeloupe"
    },
    {
        "name": "Guam",
        "value": "Guam"
    },
    {
        "name": "Guatemala",
        "value": "Guatemala"
    },
    {
        "name": "Guinea",
        "value": "Guinea"
    },
    {
        "name": "Guinea-bissau",
        "value": "Guinea-bissau"
    },
    {
        "name": "Guyana",
        "value": "Guyana"
    },
    {
        "name": "Haiti",
        "value": "Haiti"
    },
    {
        "name": "Heard and mc donald islands",
        "value": "Heard and mc donald islands"
    },
    {
        "name": "Honduras",
        "value": "Honduras"
    },
    {
        "name": "Hong kong",
        "value": "Hong kong"
    },
    {
        "name": "Hungary",
        "value": "Hungary"
    },
    {
        "name": "Iceland",
        "value": "Iceland"
    },
    {
        "name": "India",
        "value": "India"
    },
    {
        "name": "Indonesia",
        "value": "Indonesia"
    },
    {
        "name": "Iran (islamic republic of)",
        "value": "Iran (islamic republic of)"
    },
    {
        "name": "Iraq",
        "value": "Iraq"
    },
    {
        "name": "Ireland",
        "value": "Ireland"
    },
    {
        "name": "Israel",
        "value": "Israel"
    },
    {
        "name": "Italy",
        "value": "Italy"
    },
    {
        "name": "Jamaica",
        "value": "Jamaica"
    },
    {
        "name": "Japan",
        "value": "Japan"
    },
    {
        "name": "Jordan",
        "value": "Jordan"
    },
    {
        "name": "Kazakhstan",
        "value": "Kazakhstan"
    },
    {
        "name": "Kenya",
        "value": "Kenya"
    },
    {
        "name": "Kiribati",
        "value": "Kiribati"
    },
    {
        "name": "Korea, democratic people's republic of",
        "value": "Korea, democratic people's republic of"
    },
    {
        "name": "Korea, republic of",
        "value": "Korea, republic of"
    },
    {
        "name": "Kuwait",
        "value": "Kuwait"
    },
    {
        "name": "Kyrgyzstan",
        "value": "Kyrgyzstan"
    },
    {
        "name": "Lao people's democratic republic",
        "value": "Lao people's democratic republic"
    },
    {
        "name": "Latvia",
        "value": "Latvia"
    },
    {
        "name": "Lebanon",
        "value": "Lebanon"
    },
    {
        "name": "Lesotho",
        "value": "Lesotho"
    },
    {
        "name": "Liberia",
        "value": "Liberia"
    },
    {
        "name": "Libyan arab jamahiriya",
        "value": "Libyan arab jamahiriya"
    },
    {
        "name": "Liechtenstein",
        "value": "Liechtenstein"
    },
    {
        "name": "Lithuania",
        "value": "Lithuania"
    },
    {
        "name": "Luxembourg",
        "value": "Luxembourg"
    },
    {
        "name": "Macau",
        "value": "Macau"
    },
    {
        "name": "Macedonia, the former yugoslav republic of",
        "value": "Macedonia, the former yugoslav republic of"
    },
    {
        "name": "Madagascar",
        "value": "Madagascar"
    },
    {
        "name": "Malawi",
        "value": "Malawi"
    },
    {
        "name": "Malaysia",
        "value": "Malaysia"
    },
    {
        "name": "Maldives",
        "value": "Maldives"
    },
    {
        "name": "Mali",
        "value": "Mali"
    },
    {
        "name": "Malta",
        "value": "Malta"
    },
    {
        "name": "Marshall islands",
        "value": "Marshall islands"
    },
    {
        "name": "Martinique",
        "value": "Martinique"
    },
    {
        "name": "Mauritania",
        "value": "Mauritania"
    },
    {
        "name": "Mauritius",
        "value": "Mauritius"
    },
    {
        "name": "Mayotte",
        "value": "Mayotte"
    },
    {
        "name": "Mexico",
        "value": "Mexico"
    },
    {
        "name": "Micronesia, federated states of",
        "value": "Micronesia, federated states of"
    },
    {
        "name": "Moldova, republic of",
        "value": "Moldova, republic of"
    },
    {
        "name": "Monaco",
        "value": "Monaco"
    },
    {
        "name": "Mongolia",
        "value": "Mongolia"
    },
    {
        "name": "Montserrat",
        "value": "Montserrat"
    },
    {
        "name": "Morocco",
        "value": "Morocco"
    },
    {
        "name": "Mozambique",
        "value": "Mozambique"
    },
    {
        "name": "Myanmar",
        "value": "Myanmar"
    },
    {
        "name": "Namibia",
        "value": "Namibia"
    },
    {
        "name": "Nauru",
        "value": "Nauru"
    },
    {
        "name": "Nepal",
        "value": "Nepal"
    },
    {
        "name": "Netherlands",
        "value": "Netherlands"
    },
    {
        "name": "Netherlands antilles",
        "value": "Netherlands antilles"
    },
    {
        "name": "New caledonia",
        "value": "New caledonia"
    },
    {
        "name": "New zealand",
        "value": "New zealand"
    },
    {
        "name": "Nicaragua",
        "value": "Nicaragua"
    },
    {
        "name": "Niger",
        "value": "Niger"
    },
    {
        "name": "Nigeria",
        "value": "Nigeria"
    },
    {
        "name": "Niue",
        "value": "Niue"
    },
    {
        "name": "Norfolk island",
        "value": "Norfolk island"
    },
    {
        "name": "Northern mariana islands",
        "value": "Northern mariana islands"
    },
    {
        "name": "Norway",
        "value": "Norway"
    },
    {
        "name": "Oman",
        "value": "Oman"
    },
    {
        "name": "Pakistan",
        "value": "Pakistan"
    },
    {
        "name": "Palau",
        "value": "Palau"
    },
    {
        "name": "Palestinian territory",
        "value": "Palestinian territory"
    },
    {
        "name": "Panama",
        "value": "Panama"
    },
    {
        "name": "Papua new guinea",
        "value": "Papua new guinea"
    },
    {
        "name": "Paraguay",
        "value": "Paraguay"
    },
    {
        "name": "Peru",
        "value": "Peru"
    },
    {
        "name": "Philippines",
        "value": "Philippines"
    },
    {
        "name": "Pitcairn",
        "value": "Pitcairn"
    },
    {
        "name": "Poland",
        "value": "Poland"
    },
    {
        "name": "Portugal",
        "value": "Portugal"
    },
    {
        "name": "Puerto rico",
        "value": "Puerto rico"
    },
    {
        "name": "Qatar",
        "value": "Qatar"
    },
    {
        "name": "Reunion",
        "value": "Reunion"
    },
    {
        "name": "Romania",
        "value": "Romania"
    },
    {
        "name": "Russian federation",
        "value": "Russian federation"
    },
    {
        "name": "Rwanda",
        "value": "Rwanda"
    },
    {
        "name": "Saint helena",
        "value": "Saint helena"
    },
    {
        "name": "Saint kitts and nevis",
        "value": "Saint kitts and nevis"
    },
    {
        "name": "Saint lucia",
        "value": "Saint lucia"
    },
    {
        "name": "Saint pierre and miquelon",
        "value": "Saint pierre and miquelon"
    },
    {
        "name": "Saint vincent and the grenadines",
        "value": "Saint vincent and the grenadines"
    },
    {
        "name": "Samoa",
        "value": "Samoa"
    },
    {
        "name": "San marino",
        "value": "San marino"
    },
    {
        "name": "Sao tome and principe",
        "value": "Sao tome and principe"
    },
    {
        "name": "Saudi arabia",
        "value": "Saudi arabia"
    },
    {
        "name": "Senegal",
        "value": "Senegal"
    },
    {
        "name": "Serbia and montenegro",
        "value": "Serbia and montenegro"
    },
    {
        "name": "Seychelles",
        "value": "Seychelles"
    },
    {
        "name": "Sierra leone",
        "value": "Sierra leone"
    },
    {
        "name": "Singapore",
        "value": "Singapore"
    },
    {
        "name": "Slovakia",
        "value": "Slovakia"
    },
    {
        "name": "Slovenia",
        "value": "Slovenia"
    },
    {
        "name": "Solomon islands",
        "value": "Solomon islands"
    },
    {
        "name": "Somalia",
        "value": "Somalia"
    },
    {
        "name": "South africa",
        "value": "South africa"
    },
    {
        "name": "South georgia and the south sandwich islan",
        "value": "South georgia and the south sandwich islan"
    },
    {
        "name": "Spain",
        "value": "Spain"
    },
    {
        "name": "Sri lanka",
        "value": "Sri lanka"
    },
    {
        "name": "Sudan",
        "value": "Sudan"
    },
    {
        "name": "Suriname",
        "value": "Suriname"
    },
    {
        "name": "Svalbard and jan mayen islands",
        "value": "Svalbard and jan mayen islands"
    },
    {
        "name": "Swaziland",
        "value": "Swaziland"
    },
    {
        "name": "Sweden",
        "value": "Sweden"
    },
    {
        "name": "Switzerland",
        "value": "Switzerland"
    },
    {
        "name": "Syrian arab republic",
        "value": "Syrian arab republic"
    },
    {
        "name": "Taiwan, china",
        "value": "Taiwan, china"
    },
    {
        "name": "Tajikistan",
        "value": "Tajikistan"
    },
    {
        "name": "Tanzania, united republic of",
        "value": "Tanzania, united republic of"
    },
    {
        "name": "Thailand",
        "value": "Thailand"
    },
    {
        "name": "Timor-leste",
        "value": "Timor-leste"
    },
    {
        "name": "Togo",
        "value": "Togo"
    },
    {
        "name": "Tokelau",
        "value": "Tokelau"
    },
    {
        "name": "Tonga",
        "value": "Tonga"
    },
    {
        "name": "Trinidad and tobago",
        "value": "Trinidad and tobago"
    },
    {
        "name": "Tunisia",
        "value": "Tunisia"
    },
    {
        "name": "Turkey",
        "value": "Turkey"
    },
    {
        "name": "Turkmenistan",
        "value": "Turkmenistan"
    },
    {
        "name": "Turks and caicos islands",
        "value": "Turks and caicos islands"
    },
    {
        "name": "Tuvalu",
        "value": "Tuvalu"
    },
    {
        "name": "Uganda",
        "value": "Uganda"
    },
    {
        "name": "Ukraine",
        "value": "Ukraine"
    },
    {
        "name": "United arab emirates",
        "value": "United arab emirates"
    },
    {
        "name": "United kingdom",
        "value": "United kingdom"
    },
    {
        "name": "United states",
        "value": "United states"
    },
    {
        "name": "United states minor outlying islands",
        "value": "United states minor outlying islands"
    },
    {
        "name": "Uruguay",
        "value": "Uruguay"
    },
    {
        "name": "Uzbekistan",
        "value": "Uzbekistan"
    },
    {
        "name": "Vanuatu",
        "value": "Vanuatu"
    },
    {
        "name": "Vatican city state (holy see)",
        "value": "Vatican city state (holy see)"
    },
    {
        "name": "Venezuela",
        "value": "Venezuela"
    },
    {
        "name": "Viet nam",
        "value": "Viet nam"
    },
    {
        "name": "Virgin islands (british)",
        "value": "Virgin islands (british)"
    },
    {
        "name": "Virgin islands (u.s.)",
        "value": "Virgin islands (u.s.)"
    },
    {
        "name": "Wallis and futuna islands",
        "value": "Wallis and futuna islands"
    },
    {
        "name": "Western sahara",
        "value": "Western sahara"
    },
    {
        "name": "Yemen",
        "value": "Yemen"
    },
    {
        "name": "Zambia",
        "value": "Zambia"
    },
    {
        "name": "Zimbabwe",
        "value": "Zimbabwe"
    },
    {
        "name": "Other",
        "value": "Other"
    }
]
